import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import { withFirebase } from "../../Firebase";
import { isMobile } from "react-device-detect";
import getInputField from "../customFields/getInputField";
import _ from "lodash";
import moment from "moment";
import { addAudit } from "../audits/addAudits";
import MenuColumns from "./StaticList/MenuColumns";

import {
  Card,
  CardAreaMain,
  CardContent,
  Container,
  TextField,
  Button,
  CardActions,
  CardActionsMain,
  Text,
  InputAutocomplete,
  CardActionsSupplemental,
  CircleProgress
} from "reactackle";

// {
//   name: "",
//   fields: [],
//   menuItems: [],
//   searchColumns: [],
//   ...this.props.selectedRecord
// }

// {
//   name: "TEST MENU",
//   fields: [],
//   menuItems: [
//     {
//       menuCaption: "table1",
//       tableCaption: "caption1",
//       tableName: "testTable",
//       recLimit: 3000,
//       mobileRecLimit: 4000,
//       dataConditions: [
//         { fieldName: "Afld1", fieldVal: "Aval1" },
//         { fieldName: "Afld2", fieldVal: "Aval2" }
//       ]
//     },
//     {
//       menuCaption: "table2",
//       tableCaption: "caption2",
//       tableName: "testTable2",
//       recLimit: 2000,
//       mobileRecLimit: 2000,
//       dataConditions: [
//         { fieldName: "Bfld1", fieldVal: "Bval1" },
//         { fieldName: "Bfld2", fieldVal: "Bval2" }
//       ]
//     }
//   ],
//   searchColumns: []
// }

class CreateMenu extends Component {
  state = {
    data: {
      path: this.props.path,
      payload: {
        name: "",
        fields: [],
        menuItems: [],
        searchColumns: [],
        ...this.props.selectedRecord
      },
      userEmail: this.props.userProfile.userEmail
    },
    showForm: true,
    generatingStatement: false,
    statementLink: ""
  };

  //single method that work for all fields
  //takes incoming id of the field and then adds field data to state
  stateChangeHandler = (val, id, isPayload) => {
    // console.log(
    //   "val: " + JSON.stringify(val) + " id: " + id + " isPayload: " + isPayload
    // );
    let tmpState = {};
    tmpState[id] = val;

    if (isPayload) {
      this.setState(prevState => {
        if (prevState && prevState.data.payload !== null) {
          return {
            ...prevState,
            data: {
              ...prevState.data,
              payload: {
                ...prevState.data.payload,
                ...tmpState
              }
            }
          };
        } else {
          return {
            ...prevState,
            data: {
              path: prevState.data.path,
              payload: {
                ...tmpState
              }
            }
          };
        }
      });
    } else {
      this.setState(prevState => {
        return {
          ...prevState,
          ...tmpState
        };
      });
    }
  };

  saveHandler = saveAs => {
    this.stateChangeHandler(this.props.userEmail, "author", true);
    this.stateChangeHandler(false, "showForm", false);

    let myDate = moment().format("DD-MM-YYYY");

    let cloudPath = "";
    if (
      this.state.data.payload &&
      this.state.data.payload.key &&
      this.state.data.payload.key !== "" &&
      !saveAs
    ) {
      cloudPath = this.props.path + "/" + this.state.data.payload.key;
      Promise.all([
        addAudit(this.stateChangeHandler, this.props.userEmail),
        this.stateChangeHandler(this.getFormattedMenuRec(), "readyMenus", true)
      ]).then(res => {
        // console.log("UPDATE RECORD: " + cloudPath);
        // console.log("Here is the path: " + cloudPath);
        // console.log(
        //   "Here is the payload: " + JSON.stringify(this.state.data.payload)
        // );
        this.props.firebase.db
          .ref("/" + cloudPath)
          .once("value")
          .then(snap => {
            // console.log(
            //   "Before ret set payload: " +
            //     JSON.stringify(this.state.data.payload)
            // );
            return snap.ref.set(this.state.data.payload);
          })
          .catch(err => {
            console.log(err);
            return "some error: " + err;
          })
          .then(err => {
            //console.log("rec pushed");
            this.props.handleEditCancel();
          });
      });
    } else {
      // console.log(
      //   "Here is the payload: " + JSON.stringify(this.state.data.payload)
      // );
      cloudPath = this.props.path;
      Promise.all([
        addAudit(this.stateChangeHandler, this.props.userEmail),
        this.stateChangeHandler(this.getFormattedMenuRec(), "readyMenus", true)
      ]).then(res => {
        var newInv = this.props.firebase.db.ref("/" + cloudPath).push();
        // console.log(
        //   "Before ret set payload: " + JSON.stringify(this.state.data.payload)
        // );
        newInv
          .set(this.state.data.payload)
          .catch(err => {
            // console.log(err);
            return "some error: " + err;
          })
          .then(err => {
            //console.log("rec pushed");
            this.props.handleEditCancel();
          });
      });
    }

    //this.props.handleEditCancel();
  };

  getField = (fieldName, disabled) => {
    return getInputField(
      fieldName,
      "menuDesigner",
      this.state.data,
      this.stateChangeHandler,
      disabled,
      this.props.ogTableDef
    );
  };

  itemHandler = (fldName, val, rowNum) => {
    let newArray = _.cloneDeep(this.state.data.payload.fields);
    let currPayload = newArray[rowNum];
    currPayload[fldName] = val;
    this.stateChangeHandler(newArray, "fields", true);
  };

  itemAddHandler = rowNum => {
    //console.log("fromRow: " + fromRow + " updated: " + JSON.stringify(updated));
    let tmpData = _.cloneDeep(this.state.data.payload.fields);
    //console.log("Before: " + JSON.stringify(tmpData));
    tmpData.splice(rowNum + 1, 0, {
      type: "",
      selectorType: "",
      staticSource: [{ name: "" }],
      colDefs: [
        {
          name: "",
          key: "",
          editable: true,
          resizable: true
        }
      ]
    });

    //console.log("After: " + JSON.stringify(tmpData));
    this.stateChangeHandler(tmpData, "fields", true);
  };

  itemDeleteHandler = rowNum => {
    //console.log("fromRow: " + fromRow + " updated: " + JSON.stringify(updated));
    let tmpData = JSON.parse(JSON.stringify(this.state.data.payload.fields));
    //console.log("Before: " + JSON.stringify(tmpData));
    delete tmpData[rowNum];

    tmpData = tmpData.filter(item => item !== null);
    //console.log("at filter:" + JSON.stringify(currActionsList));

    this.stateChangeHandler(tmpData, "fields", true);
  };

  getFullMenuItems = menuCaption => {
    //console.log(menuCaption);
    let tmpObj = this.props.listOfTables.find(singleTable => {
      //console.log(JSON.stringify(singleTable));
      return singleTable.menu === menuCaption;
    });
    //console.log("returning: " + JSON.stringify(tmpObj));
    return tmpObj;
  };

  getFormattedMenuRec = () => {
    let fmtMenu = {};
    if (
      this.state.data.payload.menuItems &&
      this.state.data.payload.menuItems.length > 0
    ) {
      for (let i = 0; i < this.state.data.payload.menuItems.length; i++) {
        let fullDets = this.getFullMenuItems(
          this.state.data.payload.menuItems[i]
        );
        if (fullDets && fullDets !== undefined) {
          fmtMenu[fullDets.name] = {
            caption: fullDets.menu,
            tableName:
              fullDets.tableName && fullDets.tableName !== undefined
                ? fullDets.tableName
                : ""
          };
        }
      }
    }
    return fmtMenu;
  };

  tableSelectionHandler = (val, arrIndex) => {
    //console.log(arrIndex + ". val: " + JSON.stringify(val));
    let currDashFields = _.cloneDeep(this.state.data.payload.menuItems);
    let fullTableObj = this.getFullMenuItems(val);
    currDashFields[arrIndex] = {
      menuCaption: val,
      tableName:
        fullTableObj["name"] && fullTableObj["name"] !== undefined
          ? fullTableObj["name"]
          : "",
      tableCaption:
        fullTableObj["caption"] && fullTableObj["caption"] !== undefined
          ? fullTableObj["caption"]
          : "",
      recLimit: "",
      mobileRecLimit: "",
      dataConditions: []
    };
    //console.log(JSON.stringify(currDashFields));

    this.stateChangeHandler(currDashFields, "menuItems", true);
  };

  limitHandler = (val, fldName, arrIndex) => {
    let currDashFields = _.cloneDeep(this.state.data.payload.menuItems);
    currDashFields[arrIndex] = {
      ...currDashFields[arrIndex],
      [fldName]: val
    };
    this.stateChangeHandler(currDashFields, "menuItems", true);
  };

  searchColumnsAddHandler = (val, id, isPayload) => {
    //console.log("val: " + val + " id:" + id + " isPayload: " + isPayload);

    let currSearchFields = _.cloneDeep(this.state.data.payload.searchColumns);
    currSearchFields.push(val);
    this.stateChangeHandler(currSearchFields, "searchColumns", true);
  };

  getCreateMenuForm = () => {
    return (
      <div>
        {this.getField("name", false)}
        <MenuColumns
          fieldsList={this.props.listOfTables}
          // fieldsList={[
          //   { name: "testTable", menu: "TEST TABLE", caption: "TEST TABLE" }
          // ]}
          stateFieldName={"menuItems"}
          value={this.state.data.payload.menuItems}
          tableSelectionHandler={this.tableSelectionHandler}
          itemHandler={this.dashColumnsAddHandler}
          stateChangeHandler={this.stateChangeHandler}
          isPayload={true}
          title={"MENU LIST"}
          limitHandler={this.limitHandler}
          tableList={this.props.listOfTables}
          createTableList={this.props.createTable}
          // otherFields={[
          //   { src: "name", tgt: "name" },
          //   { src: "tableName", tgt: "tableName" }
          // ]}
        />
      </div>
    );
  };

  getLoader = () => {
    return (
      <CardContent>
        <CircleProgress
          indeterminate
          subtitle="Saving..."
          labelPositionY="bottom"
          labelPositionX="center"
        />
      </CardContent>
    );
  };

  getTopHeader = () => {
    return (
      <div>
        <Card>
          <CardAreaMain>
            {!isMobile && (
              <CardContent>
                <div>
                  <h1>CREATE MENU</h1>
                </div>
              </CardContent>
            )}
            <CardActions>
              <CardActionsSupplemental>
                {this.props.operationType !== "add" && (
                  <Button
                    text="DELETE"
                    onPress={e => {
                      if (
                        this.state.data.payload.key &&
                        this.state.data.payload.key !== ""
                      ) {
                        window.confirm(
                          "Are you sure you wish to delete this item?"
                        ) &&
                          this.props.handleDelete(
                            this.state.data.payload.key,
                            this.props.path
                          );
                      }
                    }}
                    colorScheme="warning"
                    disabled={!this.state.showForm}
                  />
                )}

                <Button
                  text="SAVE"
                  onPress={() => this.saveHandler(false)}
                  colorScheme="primary"
                  disabled={!this.state.showForm}
                />

                <Button
                  text="SAVE AS NEW"
                  onPress={e => {
                    if (
                      this.state.data.payload.key &&
                      this.state.data.payload.key !== ""
                    ) {
                      window.confirm(
                        "Are you sure you wish to creat a new copy of this item?"
                      ) && this.saveHandler(true);
                    }
                  }}
                  colorScheme="primary"
                  disabled={!this.state.showForm}
                />

                <Button
                  text="CANCEL"
                  onPress={() => this.props.handleEditCancel()}
                  colorScheme="primary"
                  disabled={!this.state.showForm}
                />
              </CardActionsSupplemental>
            </CardActions>
          </CardAreaMain>
        </Card>
      </div>
    );
  };

  render() {
    return (
      <div>
        <div>{this.getTopHeader()}</div>

        {isMobile && (
          <div>
            {this.state.showForm && this.getCreateMenuForm()}
            {!this.state.showForm && this.getLoader()}
          </div>
        )}
        {!isMobile && (
          <Card>
            <CardAreaMain style={{ padding: "0px" }}>
              <CardContent style={{ pading: "0px" }}>
                {this.state.showForm && this.getCreateMenuForm()}
                {!this.state.showForm && this.getLoader()}
              </CardContent>
            </CardAreaMain>
          </Card>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    userEmail: state.db.currentUser.userEmail,
    currUser: state.db.currentUser,
    isSuperAdmin: state.ui.isThisSuperAdmin,
    isAdmin: state.ui.isThisAdmin,
    userProfile: state.db.userProfile,
    selectedRecord: state.db["selected" + state.ui.tableName],
    users: state.db.users,
    projects: state.db.projects,
    contacts: state.db.contacts,
    suppliers: state.db.suppliers,
    poId: state.db.poId,
    operationType: state.ui.operationType,
    tableList: state.db.tableList === undefined ? [] : state.db.tableList,
    listOfTables: state.db.listOfTables,
    createTable: state.db.createTable
  };
}

export default compose(
  connect(
    mapStateToProps,
    null
  ),
  withFirebase
)(CreateMenu);



// WEBPACK FOOTER //
// ./src/app/components/Screens/ControlEngine/CreateMenu.jsx